import {all, call, fork, put} from "redux-saga/effects";
import {apiClient, setApiAuthBearer} from 'util/Api'
import {
  ADD_NEW_COMPANY,
  ADD_NEW_USER_SELF_MANAGED,
  CHANGE_PASSWORD,
  CONFIRM_EMAIL, FETCH_AUTH_USER_DATA, FETCH_NEW_COMPANY, MANUAL_TOKEN_REFRESH,
  MASQUERADE,
  MASQUERADE_QUIT,
  MFA_LOGIN,
  MFA_REGISTER,
  MFA_REGISTER_DELETE,
  MFA_SEND_ALT_CODE,
  MFA_VERIFY,
  REGISTER_USER,
  SIGNIN_USER,
  SIGNOUT_USER,
  SIGNOUT_USER_BY_TIMEOUT
} from "constants/ActionTypes";
import {

  userSignInSuccess,
  userSignOutSuccess,
  userDataSuccess,
  setUserData,
  setUserToken,
  setUserRefreshToken,
  confirmEmailFail,
  confirmEmailSuccess,
  registerUserFail,
  registerUserSuccess,
  masqueradeSuccess,
  setAdminUserTokenPriorToMasquerade,
  setAdminUserRefreshTokenPriorToMasquerade,
  setAdminUserMasqueradeTokensBackAsLiveTokens,
  mfaRegisterSuccess,
  mfaRegisterFail,
  mfaRegisterDeleteSuccess,
  mfaRegisterDeleteFail,
  setMfaSessionToken,
  mfaVerifySuccess,
  mfaVerifyFail,
  mfaSetLoginMeta,
  mfaSendAltCodeSuccess,
  mfaSendAltCodeFail,
  fetchAuthUserDataSuccess,
  fetchAuthUserDataFail,
  addNewUserSelfManagedSuccess,
  addNewUserSelfManagedFail,
  fetchNewCompanySuccess,
  fetchNewCompanyFail,
  addNewCompanySuccess,
  addNewCompanyFail,
  manualTokenRefreshFail,
  manualTokenRefreshSuccess,
} from "actions/Auth";
import {putResolve, takeLatest, takeLeading} from "@redux-saga/core/effects";
import IntlMessages from "../util/IntlMessages";
import {bbStandardRequestHandler, showBBNotification} from "../util/bbHelpers";
import {DANGER, INFO, RESET_PASSWORD} from "../constants/ActionTypes";
import {
  fetchCustomers, fetchCustomersSuccess,
  hideAuthLoader, reinitBreachRiskState,
  reinitCustomerState,
  reinitUsersState, resetPasswordFail, resetPasswordSuccess, setNewPasswordFail,
  setNewPasswordSuccess, userSignOut,

} from "../actions";
import {deleteApiAuthBearer} from "../util/Api";

// const createUserWithEmailPasswordRequest = async (email, password) =>
//   await  auth.createUserWithEmailAndPassword(email, password)
//     .then(authUser => authUser)
//     .catch(error => error);

const signInUserWithEmailPasswordRequest = async (email, password) =>
  await  apiClient.post('login', {
    username: email,
    password: password,
  }, {timeout: 10000})
    .then(token => token)
    .catch(error => error);

const signOutRequest = async () =>
  await  apiClient.post('logout', {},{timeout: 15000}
  )
    .then(token => token)
    .catch(error => error);

const changePasswordRequest = async (password) =>
    await  apiClient.post('set', {
      password: password,
        },{timeout: 15000}
    )
        .then(token => token)
        .catch(error => error);

/*  jfd*******************************
 *   resetPasswordRequest used to reset the user's password
     ********************************** */
const resetPasswordRequest = async (username, email) =>
    await  apiClient.post('reset', {
          username: username,
          email: email,
        },{timeout: 15000}
    )
        .then(token => token)
        .catch(error => error);

/*  jfd*******************************
 *   emailConfirmCodeRequest used to confirm email with code
     ********************************** */
const emailConfirmCodeRequest = async (confirmationCode) =>
    await  apiClient.get(`/confirm/${confirmationCode}`,{timeout: 25000}
    )
        .then(token => token)
        .catch(error => error);

/*  jfd*******************************
 *   registerUserRequest used to register a new user
     ********************************** */
const registerUserRequest = async (firstName, lastName, email, password, username, profileId, signSLA, refCode,
                                   promoCode, homepage) =>
    await  apiClient.post('register', {
          first_name: firstName,
          last_name: lastName,
          email: email,
          password: password,
          username: username,
          profile: profileId,
          signSLA: signSLA,
          refCode: refCode,
          promoCode: promoCode,
          homepage: homepage,
        },{timeout: 25000}
    )
        .then(token => token)
        .catch(error => error);

function* registerUserGenerator({payload}) {
  /*  jfd*******************************
     *   Modify these parameters and the fail and success cases below
         ********************************** */
  const standardName = "registerUser";     console.group(`${standardName} Generator...: `);
  const {firstName, lastName, email, password, username, profileId, signSLA, refCode,
    promoCode, homepage} = payload;
  const request = yield call(registerUserRequest, firstName, lastName, email, password, username, profileId, signSLA, refCode,
      promoCode, homepage);
  /*  ******END*******************/

  const didRequestSucceed = bbStandardRequestHandler(request, standardName, true, true);

  if (didRequestSucceed) {
    yield put(registerUserSuccess());
  } else {
    // showBBNotification(DANGER, <IntlMessages id={"registerUser.error"}/>, request.response.data.message, true);
    // yield put(hideAuthLoader());
    yield put(registerUserFail());
  }

  console.groupEnd();
}

export function* registerUser() {
  yield takeLeading(REGISTER_USER, registerUserGenerator);
}

/* getUserData()
*  uses the local auth token to make a call to the api to get the user data for the currently logged in user.
* returns the user data object, throws error if not
* */
const getUserDataRequest = async () =>
    await  apiClient.get('me',{timeout: 25000}
    )
        .then(({data}) => {
          //console.log("userSignIn: ", data);
          if (!data.message) { //if there is an error, the object will include a .message string
            return data;
          } else {
            console.error("getUserData data not as expected:",data.error);
            // NotificationManager.error(data.error, 'Network Error while fetching user data.', 500000);
            showBBNotification(DANGER, <IntlMessages id={"notification.error"}/>, <IntlMessages id={"notification.error.network.userData"}/>);
            throw new Error('InvalidData');
          }
        }).catch(error => error);



/* createLocalUserData(user)
*  sets the given user object as the localStorage authUser and redux store authUser.
* */
export const createLocalUserData = (userData) => {
  console.log("createLocalUserData");
  console.group("Setting the User_Data (authUser)", userData)
      try {
        localStorage.setItem("authUser", JSON.stringify(userData));
      } catch (e) {
        console.error(e);
      } finally {
        // console.info("authUser: ", localStorage.getItem("authUser"));
      }
  // console.groupEnd();
  }

/* destroyLocalAuthData()
*  destroys the local storage data related to logged in users.
* Destroys:
* token: the access_token, required for high-auth functions
* refreshToken: the refresh_token, used for low-auth functions. stays alive longer but can't do everything.
* authUser: the user object?
* */
const destroyLocalAuthData = () => {
  console.log("destroyLocalAuthData");
  try {
    localStorage.removeItem("token");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("authUser");
    localStorage.removeItem("tokenOfAdminDuringMasquerade");
    localStorage.removeItem("refreshTokenOfAdminDuringMasquerade");
    localStorage.removeItem("mfaSessionToken");

  } catch (e) {
    console.error(e);
    // put(showAuthMessage(e));
  } finally {
    console.info("Local Auth data:");
    // console.info("token: ", JSON.parse(localStorage.getItem("token")));
    // console.info("refreshToken: ", JSON.parse(localStorage.getItem("refreshToken")));
    console.info("authUser: ", JSON.parse(localStorage.getItem("authUser"))
        // "token: ", JSON.parse(localStorage.getItem("token")),
        // "refreshToken: ", JSON.parse(localStorage.getItem("refreshToken")),
        // "tokenOfAdminDuringMasquerade: ", JSON.parse(localStorage.getItem("tokenOfAdminDuringMasquerade")),
        // "refreshTokenOfAdminDuringMasquerade: ", JSON.parse(localStorage.getItem("refreshTokenOfAdminDuringMasquerade"))
    );
  }
};

/* createLocalAuthData(token, refreshToken)
*  creates the local storage data related to logged in users.
* Input: the "data" element of the returned axios request object
* Creates:
* token: the access_token, required for high-auth functions
* refreshToken: the refresh_token, used for low-auth functions. stays alive longer but can't do everything.
* authUser: the user object?
* */
export const createLocalAuthData = (token, refreshToken = null) => {
  console.group("createLocalAuthData with new token", token, "and refreshToken", refreshToken);
  const oldRefreshToken = JSON.parse(localStorage.getItem('refreshToken'));
  const oldToken = JSON.parse(localStorage.getItem('token'));
  console.log("current/old oldToken", oldToken,  "oldRefreshToken", oldRefreshToken);
  try {
    console.log("Now setting tokens with new values.");
    localStorage.setItem("token", JSON.stringify(token));
    if(!!refreshToken){
      console.log("There is a new refreshToken, setting now.");
      localStorage.setItem("refreshToken", JSON.stringify(refreshToken));
    } else {
      console.log("createLocalAuthData there was no refreshToken provided. Will not update.")
    }

  } catch (e) {
    console.error(e)
    // put(showAuthMessage(e));
  } finally {
    // console.info("Here is the new local Auth data:");
    // console.info("token: ", JSON.parse(localStorage.getItem("token")));
    // console.info("refreshToken: ", JSON.parse(localStorage.getItem("refreshToken")));
    // console.info("authUser: ", JSON.parse(localStorage.getItem("authUser")));
    console.groupEnd();
  }
};

// jfd********** `--===<>==<>==C>-<
/**
Summary. createLocalMFAAuthData

Description. sets local javascript variables to allow for page refresh during MFA verification stage

@param {string}   sessionToken           Session token used to send back with authentication code.

@yield {type} Yielded value description.

@return {type} Return value description.
   */
//*****************************************
export const createLocalMFAAuthData = (sessionToken) => {
  console.log("createLocalMFAAuthData");
  try {
    localStorage.setItem("mfaSessionToken", JSON.stringify(sessionToken));
  } catch (e) {
    console.error(e)
    // put(showAuthMessage(e));
  } finally {
    // console.info("Here is the local Auth data:");
  }
};

export const createLocalMasqueradeAuthData = (tokenOfAdminDuringMasquerade, refreshTokenOfAdminDuringMasquerade) => {

  console.log("createLocalMasqueradeAuthData");
  try {
    localStorage.setItem("tokenOfAdminDuringMasquerade", JSON.stringify(tokenOfAdminDuringMasquerade));
    localStorage.setItem("refreshTokenOfAdminDuringMasquerade", JSON.stringify(refreshTokenOfAdminDuringMasquerade));
  } catch (e) {
    console.error(e)
    // put(showAuthMessage(e));
  } finally {
    // console.info("Here is the local Auth data:");
    // console.info("tokenOfAdminDuringMasquerade: ", JSON.parse(localStorage.getItem("tokenOfAdminDuringMasquerade")));
    // console.info("refreshTokenOfAdminDuringMasquerade: ", JSON.parse(localStorage.getItem("refreshTokenOfAdminDuringMasquerade")));
    // console.info("authUser: ", JSON.parse(localStorage.getItem("authUser")));
  }
};

function* changePasswordGenerator({payload}) {
  /*  jfd*******************************
     *   Modify these parameters and the fail and success cases below
         ********************************** */
  const standardName = "changePassword";     console.group(`${standardName} Generator...: `);
  // const {username, email} = payload;
  const request = yield call(changePasswordRequest, payload);
  /*  ******END*******************/

  const didRequestSucceed = bbStandardRequestHandler(request, standardName, true, true);

  if (didRequestSucceed) {
    yield put(setNewPasswordSuccess());
    yield put(userSignOut());
  } else {
    yield put(setNewPasswordFail());
  }

  console.groupEnd();
}

function* resetPasswordGenerator({payload}) {
  /*  jfd*******************************
     *   Modify these parameters and the fail and success cases below
         ********************************** */
  const standardName = "resetPassword";     console.group(`${standardName} Generator...: `);
  const {username, email} = payload;
  const request = yield call(resetPasswordRequest, username, email);
  /*  ******END*******************/

  const didRequestSucceed = bbStandardRequestHandler(request, standardName, true, true);

  if (didRequestSucceed) {
    yield put(resetPasswordSuccess());
  } else {
    yield put(resetPasswordFail());
  }

  console.groupEnd();
}

function* confirmEmailCodeGenerator({payload}) {
  /*  jfd*******************************
     *   Modify these parameters and the fail and success cases below
         ********************************** */
  const standardName = "confirmEmailCode";     console.group(`${standardName} Generator...: `);
  const {confirmationCode} = payload;
  const request = yield call(emailConfirmCodeRequest, confirmationCode);
  /*  ******END*******************/

  const didRequestSucceed = bbStandardRequestHandler(request, standardName, true, true);

  if (didRequestSucceed) {
    yield put(confirmEmailSuccess());
  } else {
    // yield put(hideAuthLoader());
    yield put(confirmEmailFail());
  }

  console.groupEnd();
}

// const loadUserWithSuccessfulRequest  = (request) => {
//
// }
//
// const signInTasks = (request) => {
//
// }

function* signInUserWithEmailPassword({payload}) {

  /*  jfd*******************************
 *   Modify these parameters and the fail and success cases below
     ********************************** */
  const standardName = "signIn";     console.group(`${standardName} Generator...: `);
  const {email, password} = payload;
  const request = yield call(signInUserWithEmailPasswordRequest, email, password);
  /*  ******END*******************/

  const didRequestSucceed = bbStandardRequestHandler(request, standardName, true, true);

  if (didRequestSucceed) {
    console.log("signInUserWithEmailPassword request was successful. Reloading the app with this request.", request);
    /*  jfd**********22.Jan.20.14:51*****
     *   MFA check and workflow fork
     * Response is expected to match this:
     * {
            "result": "login pending",
            "access_token": null,
            "refresh_token": null,
            "require_mfa": true,
            "mfa_details": "An text with your verification code has been sent to +16xxxxxx007.",
            "mfa_preference": {
                "id": 1,
                "name": "sms",
                "description": "Text/SMS-based second-factor authentication."
            },
            "mfa_options": {
                "1": "Send a text to +16xxxxxx007.",
                "2": "Call +16xxxxxx007.",
                "3": "Email busxxxxxxxxxxxluth.co."
            },
            "session_token": "111f90f6-0afe-4a5c-b04a-029c83df4ab2"
        }
         ********************** `--===<>==<>==C>-< */

    //jfd: if MFA is required, require_mfa will be true.
    if (request.data.require_mfa) {
      console.log("This user is required to use MFA.", request.data.require_mfa, request.data.mfa_preference);

      //jfd:Step 1: look for all required materials.
      if(
          !request.data.session_token
          || !request.data.mfa_preference
          || !request.data.mfa_options
          || !request.data.mfa_details
      ) {
        //there is an error we don't have everything we think we need.
        console.warn("MFA is required but not all MFA materials were received.", request.data);

        //stop the loader?
        yield put(hideAuthLoader());
      } else { //jfd: We have all materials, proceed.
        //jfd: Step 2: store the session token
        //local storage
        setApiAuthBearer(request.data.session_token);
        yield createLocalMFAAuthData(request.data.session_token);
        //redux state
        yield put(setMfaSessionToken(request.data.session_token));

        //let the user know they need to provide their token
        showBBNotification(INFO, "Please Authenticate", request.data.mfa_details ? request.data.mfa_details : "Please use your multi-factor authentication method to complete your login.", false);

        //jfd: Step 3: store the meta to help the user in the next step know where the code was sent and other options
        yield put(mfaSetLoginMeta({
          mfa_details: request.data.mfa_details,
          mfa_preference: request.data.mfa_preference,
          mfa_options : request.data.mfa_options,
          require_mfa: request.data.require_mfa,
          result: request.data.result,
        }));

        //now the app should detect the session token, realize the user is not fully logged in, and be able to present the MFA login verification step
        console.log("MFA session token set.")
      }

    } else { //jfd:continue with normal workflow
      console.log("This user is not required to use MFA.", "require_mfa", request.data.require_mfa);
      setApiAuthBearer(request.data.access_token);
      yield createLocalAuthData(request.data.access_token, request.data.refresh_token);
      //set the token data into the state
      yield put(setUserToken(request.data.access_token));
      yield put(setUserRefreshToken(request.data.refresh_token));
      yield put(fetchCustomersSuccess(request.data.customers));
      //fetch the current user's data
      const userData = yield call(getUserDataRequest);
      if (userData.message) {
        console.error("There was a problem logging in. Couldn't get the user's data.")
        // yield put(showAuthMessage(userData.message + "... Couldn't get the user's data."));
      } else {
        yield createLocalUserData(userData);
        yield put(setUserData(userData));
        yield put(userDataSuccess()); //TODO: put some actual checking of the state before sending success
        yield put(userSignInSuccess());
        console.log("%cSignin workflow successful.", "color:green;");
        //fetch some initial data
        yield put(fetchCustomers());
      }
    }
  } else {
    // showBBNotification(DANGER, <IntlMessages id={"signIn.error.network"}/>, <IntlMessages id={"signIn.error.network.detail"}/>, true);
    yield put(hideAuthLoader());
  }

  console.groupEnd();

  // console.group("Logging user in...")
  // try {
  //   const signInUser =
  //   if (signInUser.response && signInUser.response.data && signInUser.response.data.error) {
  //     console.error("Error while attempting to log in.", signInUser, typeof(signInUser));
  //       showBBNotification(DANGER, <IntlMessages id={"signIn.error"}/>, signInUser.response.data.error, true);
  //     yield put(hideAuthLoader());
  //     // yield put(showAuthMessage(signInUser.message));
  //   } else {
  //     console.log("%cNetwork signin request successful.", "color:green;");
  //
  //
  //
  //
  //   }
  // } catch (error) {
  //   console.error("Network error.", error);
  //
  // }
  // console.groupEnd();
}

function* signOut({payload}) {
  /*  jfd*******************************
   *   Modify these parameters and the fail and success cases below
       ********************************** */
  const standardName = "signOut";     console.group(`${standardName} Generator...: `);
  // const {username, email} = payload;
  const request = yield fork(signOutRequest);
  /*  ******END*******************/



  // const didRequestSucceed = bbStandardRequestHandler(request, standardName, false, true);
  destroyLocalAuthData(); //no matter what, destroy the local data
  deleteApiAuthBearer(); //unset the API auth header

  // if (didRequestSucceed) {
  //   yield put(resetPasswordSuccess());
  // } else {
  //   yield put(resetPasswordFail());
  // }


  yield put(userSignOutSuccess()); //no matter what, destroy the state data and log out.
  //destroy state data
  yield putResolve(reinitCustomerState());
  yield putResolve(reinitUsersState());
  yield putResolve(reinitBreachRiskState());

  showBBNotification(INFO, <IntlMessages id={"signOut.success"}/>, <IntlMessages id={"signOut.success.detail"}/>);
  console.groupEnd();


  // console.group("Logging user out...")
  // // const {logoutMessage} = payload;
  // try {
  //   const signOutUser = yield call(signOutRequest);
  //   destroyLocalAuthData(); //no matter what, destroy the local data
  //   //TODO: figure out why there is a stray request to fetch customer data from the active clients tile
  //   deleteApiAuthBearer(); //unset the API auth header
  //   if (signOutUser.data === undefined) {
  //     console.warn("Network request came up empty.", signOutUser);
  //     showBBNotification(INFO, <IntlMessages id={"signOut.title"}/>, <IntlMessages id={"signOut.badNetwork"}/>);
  //   } else {
  //     console.log("%cNetwork logout request successful.", "color:green;");
  //     showBBNotification(INFO, <IntlMessages id={"signOut.title"}/>, <IntlMessages id={"signOut.normal"}/>);
  //   }
  //   //destroy state data
  //   yield putResolve(reinitCustomerState());
  //   yield putResolve(reinitUsersState());
  //   yield put(userSignOutSuccess()); //no matter what, destroy the state data and log out.
  // } catch (error) {
  //   console.warn("Network request error:", error);
  //   // this is a 401 error, so don't show a notification since it is handled by a 401 timout interceptor.
  //   showBBNotification(INFO, <IntlMessages id={"signOut.title"}/>, <IntlMessages id={"signOut.badNetwork"}/>);
  // }
  // console.groupEnd()
}

function* signOutTimeOut({payload = {}}) {
  /*  jfd*******************************
   *   Modify these parameters and the fail and success cases below
       ********************************** */
  const standardName = "signOutTimeout";     console.group(`${standardName} Generator...: `);
  const {wasIdle = false} = payload;
  const request = yield fork(signOutRequest);
  /*  ******END*******************/

  // const didRequestSucceed = bbStandardRequestHandler(request, standardName, false, true);
  destroyLocalAuthData(); //no matter what, destroy the local data
  deleteApiAuthBearer(); //unset the API auth header

  // if (didRequestSucceed) {
  //   yield put(resetPasswordSuccess());
  // } else {
  //   yield put(resetPasswordFail());
  // }


  yield put(userSignOutSuccess()); //no matter what, destroy the state data and log out.
  //destroy state data
  yield putResolve(reinitCustomerState());
  yield putResolve(reinitUsersState());
  yield putResolve(reinitBreachRiskState());

  // console.log("signing user out... wasIdle", wasIdle, payload);
  if (wasIdle){
    showBBNotification(INFO, <IntlMessages id={"signOutTimeout.success"}/>, <IntlMessages id={"signOutTimeout.success.idle.detail"}/>, true);
  } else {
    showBBNotification(INFO, <IntlMessages id={"signOutTimeout.success"}/>, <IntlMessages id={"signOutTimeout.success.detail"}/>, true);
  }
  console.groupEnd();



  // console.group("Timing user out...");
  // destroyLocalAuthData(); //destroy the local data
  // deleteApiAuthBearer(); //unset the API auth header
  // //destroy state data
  // yield putResolve(reinitCustomerState());
  // yield putResolve(reinitUsersState());
  // yield put(userSignOutSuccess());
  // showBBNotification(INFO, <IntlMessages id={"signOut.timeout"}/>, <IntlMessages id={"signOut.timeout.detail"}/>, true);
  // console.groupEnd();
}

// export function* createUserAccount() {
//   yield takeEvery(SIGNUP_USER, createUserWithEmailPassword);
// }

export function* signInUser() {
  yield takeLatest(SIGNIN_USER, signInUserWithEmailPassword);
}

export function* signOutUser() {
  yield takeLeading(SIGNOUT_USER, signOut);
}

export function* changePassword() {
  yield takeLeading(CHANGE_PASSWORD, changePasswordGenerator);
}

export function* resetPassword() {
  yield takeLeading(RESET_PASSWORD, resetPasswordGenerator);
}

export function* confirmEmail() {
  yield takeLeading(CONFIRM_EMAIL, confirmEmailCodeGenerator);
}


export function* timeOutUser() {
  yield takeLeading(SIGNOUT_USER_BY_TIMEOUT, signOutTimeOut);
}


/* ***************************
   Masquerading as a user or customer
   *************************** */

const masqueradeRequest = async (userId, customerId) =>
    await  apiClient.post(`/masquerade`,{
          user: userId,
          customer: customerId,
        },{timeout: 25000}
    )
        .then(data => data)
        .catch(error => error);

function* masqueradeGenerator({payload}) {
  /*  jfd*******************************
   *   Modify these parameters and the fail and success cases below
       ********************************** */
  const standardName = "masquerade";     console.group(`${standardName} Generator...: `);
  const {userId, customerId, saveThisToken, saveThisRefreshToken} = payload;
  const request = yield call(masqueradeRequest, userId, customerId);
  /*  ******END*******************/

  const didRequestSucceed = bbStandardRequestHandler(request, standardName, true, true);

  if (didRequestSucceed) {
    console.log("Masquerade request was successful. Reloading the app with this request.", request);

    //dismiss the modal
    yield put(masqueradeSuccess());


    //FIRST, save the current admin token for when the user later exits the Masquerade
    yield put(setAdminUserTokenPriorToMasquerade());
    yield put(setAdminUserRefreshTokenPriorToMasquerade());

    //SECOND, destroy the current session but don't log out
    /*  jfd*******************************
   *   careful - the following lines are duplicated from the signout function
       ********************************** */
    destroyLocalAuthData(); //no matter what, destroy the local data
    deleteApiAuthBearer(); //unset the API auth header
    // yield put(userSignOutSuccess()); //no matter what, destroy the state data and log out.
    //destroy state data
    yield putResolve(reinitCustomerState());
    yield putResolve(reinitUsersState());
    yield putResolve(reinitBreachRiskState());
    /*  jfd*******************************
   *   END OF DUPLICATED CAREFUL CODE FROM SIGNOUT FUNCTION
       ********************************** */

    /*  jfd*******************************
   *   careful - the following lines are duplicated from the signin function
       ********************************** */
    setApiAuthBearer(request.data.access_token);
    yield createLocalAuthData(request.data.access_token, request.data.refresh_token);
    //added for masquerade:
    yield createLocalMasqueradeAuthData(saveThisToken, saveThisRefreshToken)
    //set the token data into the state
    yield put(setUserToken(request.data.access_token));
    yield put(setUserRefreshToken(request.data.refresh_token));
    yield put(fetchCustomersSuccess(request.data.customers));
    //fetch the current user's data
    const userData = yield call(getUserDataRequest);
    if (userData.message) {
      console.error("There was a problem reloading during masquerade. Couldn't get the user's data.")
      // yield put(showAuthMessage(userData.message + "... Couldn't get the user's data."));
    } else {
      yield createLocalUserData(userData);
      yield put(setUserData(userData));
      yield put(userDataSuccess()); //TODO: put some actual checking of the state before sending success
      yield put(userSignInSuccess());
      console.log("%cMasquerade reload workflow successful.", "color:green;");
      //fetch some initial data
      yield put(fetchCustomers());
    }
    /*  jfd*******************************
   *   END OF DUPLICATED CAREFUL CODE FROM SIGNIN FUNCTION
       ********************************** */


  } else {
    // yield put(masqueradeFail({
    //   affectedElementId: affectedElementId,
    //   request: request.data,
    // }));
    console.log("Masquerade request was not success");
  }

  console.groupEnd();
}

export function* watchLatestMasqueradeGenerator() {
  yield takeLatest(MASQUERADE, masqueradeGenerator);
}


/* ***************************
   Masquerading as a user or customer
   *************************** */

const manualTokenRefreshRequest = async (refreshToken) =>
    await  apiClient.post(`/refresh`,{},{
          headers: {
            'Authorization' : `Bearer ${refreshToken}` //this is a manual refresh, so use the refresh token here
          }
    }
    )
        .then(data => data)
        .catch(error => error);

function* manualTokenRefreshGenerator({payload}) {
  /*  jfd*******************************
   *   Modify these parameters and the fail and success cases below
       ********************************** */
  //special case: get the local storage refreshToken
  const refreshToken = JSON.parse(localStorage.getItem('refreshToken'));
  const oldToken = JSON.parse(localStorage.getItem('token'));

  const standardName = "manualTokenRefresh";     console.group(`${standardName} Generator...: `);
  const {} = payload;
  const request = yield call(manualTokenRefreshRequest, refreshToken);
  /*  ******END*******************/

  const didRequestSucceed = bbStandardRequestHandler(request, standardName, false, true);

  if (didRequestSucceed) {
    console.log("Manual refresh token request was successful. Reloading the app with this request.", request);

    //safely open request.data using a try to catch any other types of issues.
    try{
      /*  jfd*******************************
   *   careful - the following lines are similar to logout and masquerade function
       ********************************** */
      destroyLocalAuthData(); //no matter what, destroy the local data
      deleteApiAuthBearer(); //unset the API auth header
      yield putResolve(reinitUsersState());
      /*  jfd*******************************
     *   END OF DUPLICATED CAREFUL CODE FROM SIGNOUT FUNCTION
         ********************************** */

      /*  jfd*******************************
     *   careful - the following lines are duplicated from the signin function
         ********************************** */
      setApiAuthBearer(request.data.access_token);
      yield createLocalAuthData(request.data.access_token);
      //set the token data into the state
      yield put(setUserToken(request.data.access_token));
      // yield put(setUserRefreshToken(refreshToken));
      //fetch the current user's data
      const userData = yield call(getUserDataRequest);
      if (userData.message) {
        console.error("There was a problem reloading during manualTokenRefresh. Couldn't get the user's data.")
        // yield put(showAuthMessage(userData.message + "... Couldn't get the user's data."));
      } else {
        yield createLocalUserData(userData);
        yield put(setUserData(userData));
        yield put(userDataSuccess());

        //check that tokens are set as expected
        const newRefreshToken = JSON.parse(localStorage.getItem('refreshToken'));
        const newToken = JSON.parse(localStorage.getItem('token'));
        if(newRefreshToken
            && newToken
            && refreshToken
            && oldToken
            && newRefreshToken === refreshToken
            && newToken !== oldToken
        ) {
          console.log("%cManualTokenRefresh reload workflow successful.", "color:green;");
        } else {
          console.warn("ManualTokenRefresh reload workflow reached the end, but tokens were not as expected in localStorage", "oldToken", oldToken, "newToken", newToken, "refreshToken", refreshToken, "newRefreshToken", newRefreshToken);
        }

      }
      /*  jfd*******************************
     *   END OF DUPLICATED CAREFUL CODE FROM SIGNIN FUNCTION
         ********************************** */
    } catch (e) {
      console.warn(e);
    }

    yield put(manualTokenRefreshSuccess(
        {
          inboundData: request.data,
        }));


  } else {
    // yield put(manualTokenRefreshFail({
    //   affectedElementId: affectedElementId,
    //   request: request.data,
    // }));
    console.log("ManualTokenRefresh request was not success");
    yield put(manualTokenRefreshFail({

    }));
  }

  console.groupEnd();
}

export function* watchLatestManualTokenRefreshGenerator() {
  yield takeLatest(MANUAL_TOKEN_REFRESH, manualTokenRefreshGenerator);
}

/* ***************************
   Masquerading as a user or customer
   *************************** */

function* masqueradeQuitGenerator({payload}) {
  /*  jfd*******************************
   *   Modify these parameters and the fail and success cases below
       ********************************** */
  const standardName = "masqueradeQuit";     console.group(`${standardName} Generator...: `);
  const {savedToken, savedRefreshToken} = payload;

  // const request = yield call(masqueradeQuitRequest, userId, customerId);
  /*  ******END*******************/

  // const didRequestSucceed = bbStandardRequestHandler(request, standardName, true, true);

  // if (didRequestSucceed) {
  //   console.log("masqueradeQuit request was successful. Reloading the app with this request.", request);

    //SECOND, destroy the current session but don't log out
    /*  jfd*******************************
   *   careful - the following lines are duplicated from the signout function
       ********************************** */
    destroyLocalAuthData(); //no matter what, destroy the local data
    deleteApiAuthBearer(); //unset the API auth header
    // yield put(userSignOutSuccess()); //no matter what, destroy the state data and log out.
    //destroy state data
    yield putResolve(reinitCustomerState());
    yield putResolve(reinitUsersState());
    yield putResolve(reinitBreachRiskState());
    /*  jfd*******************************
   *   END OF DUPLICATED CAREFUL CODE FROM SIGNOUT FUNCTION
       ********************************** */

  yield put(setAdminUserMasqueradeTokensBackAsLiveTokens());

    /*  jfd*******************************
   *   careful - the following lines are duplicated from the signin function
       ********************************** */
    setApiAuthBearer(savedToken);
    yield createLocalAuthData(savedToken, savedRefreshToken);
    //set the token data into the state
    yield put(setUserToken(savedToken));
    yield put(setUserRefreshToken(savedRefreshToken));
    // yield put(fetchCustomersSuccess(request.data.customers));
    //fetch the current user's data
    const userData = yield call(getUserDataRequest);
    if (userData.message) {
      console.error("There was a problem reloading during masqueradeQuit. Couldn't get the user's data.")
      // yield put(showAuthMessage(userData.message + "... Couldn't get the user's data."));
    } else {
      yield createLocalUserData(userData);
      yield put(setUserData(userData));
      yield put(userDataSuccess()); //TODO: put some actual checking of the state before sending success
      yield put(userSignInSuccess());
      console.log("%cmasqueradeQuit reload workflow successful.", "color:green;");
      //fetch some initial data
      yield put(fetchCustomers());
    }
    /*  jfd*******************************
   *   END OF DUPLICATED CAREFUL CODE FROM SIGNIN FUNCTION
       ********************************** */


  // } else {
  //   // yield put(masqueradeQuitFail({
  //   //   affectedElementId: affectedElementId,
  //   //   request: request.data,
  //   // }));
  //   console.log("masqueradeQuit request was not success");
  // }

  console.groupEnd();
}

export function* watchLatestMasqueradeQuitGenerator() {
  yield takeLatest(MASQUERADE_QUIT, masqueradeQuitGenerator);
}

/* ***************************
   MFA Registration
   *************************** */

const mfaRegisterRequest = async (mfaPreference, mfaPhone) =>
    await  apiClient.post(`/mfa/register`,{
          mfa_preference: mfaPreference,
          mfa_phone: mfaPhone,
        },{timeout: 25000}
    )
        .then(data => data)
        .catch(error => error);

function* mfaRegisterGenerator({payload}) {
  /*  jfd*******************************
   *   Modify these parameters and the fail and success cases below
       ********************************** */
  const standardName = "mfaRegister";     console.group(`${standardName} Generator...: `);
  const {userId, mfaPreference, mfaPhone} = payload;
  const request = yield call(mfaRegisterRequest, mfaPreference, mfaPhone);
  /*  ******END*******************/

  const didRequestSucceed = bbStandardRequestHandler(request, standardName, true, true, false);

  if (didRequestSucceed) {
    yield put(mfaRegisterSuccess(
        {
          userId: userId,
          inboundData: request.data,
        }));
  } else {
    yield put(mfaRegisterFail({

    }));
  }

  console.groupEnd();
}

export function* watchLatestMfaRegisterGenerator() {
  yield takeLatest(MFA_REGISTER, mfaRegisterGenerator);
}

/* ***************************
   MFA Registration Deletion
   *************************** */

const mfaRegisterDeleteRequest = async () =>
    await  apiClient.delete(`/mfa/register`,
    { data :{}
    },{timeout: 25000}
)

function* mfaRegisterDeleteGenerator({payload}) {
  /*  jfd*******************************
   *   Modify these parameters and the fail and success cases below
       ********************************** */
  const standardName = "mfaRegisterDelete";     console.group(`${standardName} Generator...: `);
  const {userId} = payload;
  const request = yield call(mfaRegisterDeleteRequest);
  /*  ******END*******************/

  const didRequestSucceed = bbStandardRequestHandler(request, standardName, true, true, true);

  if (didRequestSucceed) {
    yield put(mfaRegisterDeleteSuccess(
        {
          userId: userId,
          inboundData: request.data,
        }));
  } else {
    yield put(mfaRegisterDeleteFail({

    }));
  }

  console.groupEnd();
}

export function* watchLatestMfaRegisterDeleteGenerator() {
  yield takeLatest(MFA_REGISTER_DELETE, mfaRegisterDeleteGenerator);
}

/* ***************************
   MFA Verification (During Registration)
   *************************** */

const mfaVerifyRequest = async (mfaAuthCode) =>
    await  apiClient.post(`/mfa/verify`,{
          auth_code: mfaAuthCode
        },{timeout: 25000}
    )
        .then(data => data)
        .catch(error => error);

function* mfaVerifyGenerator({payload}) {
  /*  jfd*******************************
   *   Modify these parameters and the fail and success cases below
       ********************************** */
  const standardName = "mfaVerify";     console.group(`${standardName} Generator...: `);
  const {userId, mfaAuthCode} = payload;
  const request = yield call(mfaVerifyRequest, mfaAuthCode);
  /*  ******END*******************/

  const didRequestSucceed = bbStandardRequestHandler(request, standardName, true, true, false);

  if (didRequestSucceed) {
    yield put(mfaVerifySuccess(
        {
          userId: userId,
          inboundData: request.data,
        }));
  } else {
    yield put(mfaVerifyFail({

    }));
  }

  console.groupEnd();
}

export function* watchLatestMfaVerifyGenerator() {
  yield takeLatest(MFA_VERIFY, mfaVerifyGenerator);
}

/* ***************************
   MFA Login Verification (During Login)
   *************************** */

const mfaLoginVerifyRequest = async (mfaSessionToken, mfaAuthCode, mfaMethodId) =>
    await  apiClient.post(`/login/verify`,{
          session_token: mfaSessionToken,
          auth_code: mfaAuthCode,
          mfa_method: mfaMethodId
        },{timeout: 25000}
    )
        .then(data => data)
        .catch(error => error);

function* mfaLoginVerifyGenerator({payload}) {
  /*  jfd*******************************
   *   Modify these parameters and the fail and success cases below
       ********************************** */
  const standardName = "mfaLoginVerify";     console.group(`${standardName} Generator...: `);
  const {mfaSessionToken, mfaAuthCode, mfaMethodId} = payload;
  const request = yield call(mfaLoginVerifyRequest, mfaSessionToken, mfaAuthCode, mfaMethodId);
  /*  ******END*******************/

  const didRequestSucceed = bbStandardRequestHandler(request, standardName, true, true, false);

  if (didRequestSucceed) {
    console.log("MFA code login successful, loading app.");

    //delete the local Auth Data (to get ride of the MFA token)
    destroyLocalAuthData();
    deleteApiAuthBearer(); //unset the API auth header

    /*  jfd**********22.Jan.20.17:58*****
     *   THIS CODE COPIED FROM NON-MFA LOGIN FLOW
         ********************** `--===<>==<>==C>-< */
      setApiAuthBearer(request.data.access_token);
      yield createLocalAuthData(request.data.access_token, request.data.refresh_token);
      //set the token data into the state
      yield put(setUserToken(request.data.access_token));
      yield put(setUserRefreshToken(request.data.refresh_token));
      yield put(fetchCustomersSuccess(request.data.customers));
      //fetch the current user's data
      const userData = yield call(getUserDataRequest);
      if (userData.message) {
        console.error("There was a problem logging in. Couldn't get the user's data.")
        // yield put(showAuthMessage(userData.message + "... Couldn't get the user's data."));
      } else {
        yield createLocalUserData(userData);
        yield put(setUserData(userData));
        yield put(userDataSuccess()); //TODO: put some actual checking of the state before sending success
        yield put(userSignInSuccess());
        console.log("%cSignin workflow successful.", "color:green;");
        //fetch some initial data
        yield put(fetchCustomers());
      }

    } else {
      // showBBNotification(DANGER, <IntlMessages id={"signIn.error.network"}/>, <IntlMessages id={"signIn.error.network.detail"}/>, true);
      yield put(hideAuthLoader());
    }
  /*  jfd**********22.Jan.20.17:58*****
     *   END CODE COPY FROM LOGIN FLOW
         ********************** `--===<>==<>==C>-< */

  console.groupEnd();
}

export function* watchLatestMfaLoginVerifyGenerator() {
  yield takeLatest(MFA_LOGIN, mfaLoginVerifyGenerator);
}

/* ***************************
   MFA Send an Alternative code after login creds already provided
   *************************** */

const mfaSendAltCodeRequest = async (mfaSessionToken, mfaAltMethodId) =>
    await  apiClient.post(`/mfa/request`,{
          session_token: mfaSessionToken,
          mfa_method: mfaAltMethodId
        },{timeout: 25000}
    )
        .then(data => data)
        .catch(error => error);

function* mfaSendAltCodeGenerator({payload}) {
  /*  jfd*******************************
   *   Modify these parameters and the fail and success cases below
       ********************************** */
  const standardName = "mfaSendAltCode";     console.group(`${standardName} Generator...: `);
  const {mfaSessionToken, mfaAltMethodId} = payload;
  const request = yield call(mfaSendAltCodeRequest, mfaSessionToken, mfaAltMethodId);
  /*  ******END*******************/

  const didRequestSucceed = bbStandardRequestHandler(request, standardName, false, true, false);

  if (didRequestSucceed) {
    const mfaDetails = request.data.mfa_details ? request.data.mfa_details : null;
    if (mfaDetails) {
      showBBNotification(INFO, "Alternative Code Sent", mfaDetails, true);
    }

    yield put(mfaSendAltCodeSuccess(
        {
          inboundData: request.data,
        }));
  } else {
    yield put(mfaSendAltCodeFail({

    }));
  }

  console.groupEnd();
}

export function* watchLatestMfaSendAltCodeGenerator() {
  yield takeLatest(MFA_SEND_ALT_CODE, mfaSendAltCodeGenerator);
}

/* ***************************
   Fetching authUser Data me
   *************************** */

const getAuthUserDataRequest = async () =>
    await  apiClient.get(`me`, {timeout: 5000}
    )
        .then(data => data)
        .catch(error => error);

function* getAuthUserDataGenerator({payload}) {
  /*  jfd*******************************
   *   Modify these parameters and the fail and success cases below
       ********************************** */
  const standardName = "fetchAuthUserData";     console.group(`${standardName} Generator...: `);
  // const {} = payload;
  const request = yield call(getAuthUserDataRequest);
  /*  ******END*******************/

  const didRequestSucceed = bbStandardRequestHandler(request, standardName, false, true);

  if (didRequestSucceed) {
    yield put(fetchAuthUserDataSuccess(
        {
          // customerId: customerId,
          // cycleId: cycleId,
          inboundData: request.data,
        }));
  } else {
    yield put(fetchAuthUserDataFail({
      // cycleId: cycleId,
      request: request.data,
    }));
  }

  console.groupEnd();
}

export function* watchLeadingGetAuthUserDataGenerator() {
  yield takeLeading(FETCH_AUTH_USER_DATA, getAuthUserDataGenerator);
}


/*  sarahp*******************************
 *   addNewUserSelfManaged saga for adding a user without an associated customer
     ********************************** */
const addNewUserSelfManagedRequest = async (firstName, lastName, email, password, username, signSLA, ref, promo, homepage) =>
    await  apiClient.post('/register/new', {
          first_name: firstName,
          last_name: lastName,
          email: email,
          password: password,
          username: username,
          signSLA: signSLA,
          ref: ref,
          promo: promo,
          homepage: homepage,
        },{timeout: 25000}
    )
        .then(token => token)
        .catch(error => error);

function* addNewUserSelfManagedGenerator({payload}) {
  /*  sarahp*******************************
     *   Modify these parameters and the fail and success cases below
         ********************************** */
  const standardName = "addNewUserSelfManaged";     console.group(`${standardName} Generator...: `);
  const {firstName, lastName, email, password, username, signSLA, ref, promo, homepage} = payload;
  const request = yield call(addNewUserSelfManagedRequest, firstName, lastName, email, password, username, signSLA, ref, promo, homepage );
  /*  ******END*******************/

  const didRequestSucceed = bbStandardRequestHandler(request, standardName, true, true);

  if (didRequestSucceed) {
    yield put(addNewUserSelfManagedSuccess(
        {
            inboundData: request.data,
    }));
  } else {
    yield put(addNewUserSelfManagedFail(
        {
          inboundData: request.data,
        }
    ));
  }

  console.groupEnd();
}

export function* watchLeadingAddNewUserSelfManagedGenerator() {
  yield takeLeading(ADD_NEW_USER_SELF_MANAGED, addNewUserSelfManagedGenerator);
}

/*  sarahp*******************************
 *   Fetch entity details for new account for self subscription sign ups
     ********************************** */
const fetchNewCompanyRequest = async () =>
    await  apiClient.get('/customer/register',{timeout: 25000}
    )
        .then(token => token)
        .catch(error => error);

function* fetchNewCompanyGenerator({payload}) {
  /*  sarahp*******************************
     *   Modify these parameters and the fail and success cases below
         ********************************** */
  const standardName = "fetchNewCompany";     console.group(`${standardName} Generator...: `);
  // const {firstName, lastName, email, password, username, } = payload;
  const request = yield call(fetchNewCompanyRequest,);
  /*  ******END*******************/

  const didRequestSucceed = bbStandardRequestHandler(request, standardName, false, true);

  if (didRequestSucceed) {
    yield put(fetchNewCompanySuccess(
        {
          inboundData: request.data,
        }));
  } else {
    yield put(fetchNewCompanyFail(
        {
          inboundData: request.response.data,
        }
    ));
  }

  console.groupEnd();
}

export function* watchLeadingFetchNewCompanyGenerator() {
  yield takeLeading(FETCH_NEW_COMPANY, fetchNewCompanyGenerator);
}

/*  sarahp*******************************
 *   Add entity details for new account for self subscription sign ups
     ********************************** */
const addNewCompanyRequest = async (entityId) =>
    await  apiClient.post('/customer/register',{
      entity: entityId,
    },{timeout: 25000}
    )
        .then(token => token)
        .catch(error => error);

function* addNewCompanyGenerator({payload}) {
  /*  sarahp*******************************
     *   Modify these parameters and the fail and success cases below
         ********************************** */
  const standardName = "addNewCompany";     console.group(`${standardName} Generator...: `);
  const {entityId} = payload;
  const request = yield call(addNewCompanyRequest, entityId);
  /*  ******END*******************/

  const didRequestSucceed = bbStandardRequestHandler(request, standardName, true, true);

  if (didRequestSucceed) {
    yield put(addNewCompanySuccess(
        {
          inboundData: request.data,
        }));

    /*  jfd*******************************
  *   careful - the following lines are duplicated from the signin function
      ********************************** */
    setApiAuthBearer(request.data.access_token);
    yield createLocalAuthData(request.data.access_token, request.data.refresh_token);
    //set the token data into the state
    yield put(setUserToken(request.data.access_token));
    yield put(setUserRefreshToken(request.data.refresh_token));
    yield put(fetchCustomersSuccess(request.data.customers));
    //fetch the current user's data
    const userData = yield call(getUserDataRequest);
    if (userData.message) {
      console.error("There was a problem reloading after registering company. Couldn't get the user's data.")
      // yield put(showAuthMessage(userData.message + "... Couldn't get the user's data."));
    } else {
      yield createLocalUserData(userData);
      yield put(setUserData(userData));
      yield put(userDataSuccess()); //TODO: put some actual checking of the state before sending success
      yield put(userSignInSuccess());
      console.log("Company registration reload successful", "color:green;");
      //fetch some initial data
      yield put(fetchCustomers());
    }
    /*  jfd*******************************
   *   END OF DUPLICATED CAREFUL CODE FROM SIGNIN FUNCTION
       ********************************** */
  } else {
    yield put(addNewCompanyFail(
        {
          inboundData: request.response.data,
        }
    ));
  }

  console.groupEnd();
}

export function* watchLeadingAddNewCompanyGenerator() {
  yield takeLeading(ADD_NEW_COMPANY, addNewCompanyGenerator);
}

export default function* rootSaga() {
  yield all([
      fork(signInUser),
    // fork(createUserAccount),
    fork(signOutUser),
    fork(timeOutUser),
    fork(changePassword),
    fork(resetPassword),
    fork(confirmEmail),
    fork(registerUser),
    fork(watchLatestMasqueradeGenerator),
    fork(watchLatestMasqueradeQuitGenerator),
    fork(watchLatestMfaRegisterGenerator),
    fork(watchLatestMfaRegisterDeleteGenerator),
    fork(watchLatestMfaVerifyGenerator),
    fork(watchLatestMfaLoginVerifyGenerator),
    fork(watchLatestMfaSendAltCodeGenerator),
    fork(watchLeadingGetAuthUserDataGenerator),
    fork(watchLeadingAddNewUserSelfManagedGenerator),
    fork(watchLeadingFetchNewCompanyGenerator),
    fork(watchLeadingAddNewCompanyGenerator),
    fork(watchLatestManualTokenRefreshGenerator)

    //fork(fetchUserData)
  ]);
}